import * as React from 'react'
import { LoaderPinwheel } from 'lucide-react'
import { cn } from '@/lib/utils'

interface LoadingMessageProps extends React.HTMLAttributes<HTMLDivElement> {
  message?: string
  children?: React.ReactNode
  size?: 'sm' | 'md' | 'lg'
  centered?: boolean
}

export const LoadingMessage = React.forwardRef<
  HTMLDivElement,
  LoadingMessageProps
>(
  (
    { className, message, children, size = 'md', centered = false, ...props },
    ref
  ) => {
    const content = message || children

    const getSizeClass = () => {
      switch (size) {
        case 'sm':
          return 'h-4 w-4'
        case 'lg':
          return 'h-10 w-10'
        case 'md':
        default:
          return 'h-6 w-6'
      }
    }

    return (
      <div
        ref={ref}
        className={cn(
          'flex flex-col items-center gap-2',
          centered && 'justify-center min-h-[100px]',
          className
        )}
        {...props}
      >
        <LoaderPinwheel
          className={cn('animate-spin text-primary', getSizeClass())}
        />
        {content && (
          <span className="text-sm text-muted-foreground">{content}</span>
        )}
      </div>
    )
  }
)

LoadingMessage.displayName = 'LoadingMessage'
